import React from "react";
import classes from "./LoadingBar.module.css";

const LoadingBar = () => <div className={classes.LoadingBar}></div>;

export default LoadingBar;
